import { ClientesSinContacto } from "../../bussines/entities/EstadisticasCRM.entity";

export class ClientesSinContactoModel implements ClientesSinContacto {
    constructor(
        public codCliente: string,
        public clienteDenominacion: string,
        public producto: string,
        public fecha: Date
    ) { }

    serialize(): ClientesSinContacto {
        return {
            codCliente: this.codCliente,
            clienteDenominacion: this.clienteDenominacion,
            producto: this.producto,
            fecha: this.fecha
        }
    }

    static deserialize(entity: ClientesSinContacto): ClientesSinContactoModel {
        return new ClientesSinContactoModel(
            entity.codCliente ?? '',
            entity.clienteDenominacion ?? '',
            entity.producto ?? '',
            entity.fecha ?? ''
        );
    }
}